import { render, staticRenderFns } from "./stationeryList.vue?vue&type=template&id=ffe59ba4&scoped=true"
import script from "./stationeryList.vue?vue&type=script&lang=js"
export * from "./stationeryList.vue?vue&type=script&lang=js"
import style0 from "./stationeryList.vue?vue&type=style&index=0&id=ffe59ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe59ba4",
  null
  
)

export default component.exports